import { isValid } from "date-fns";

import { defaultDateFormat } from "@/core/date";

import {
    companyAddressDefaultValues,
    companyAddressFixture,
    companyContactDefaultValues,
    companyContactFixture,
    companyFinancialDefaultValues,
    companyFinancialFixture,
    CompanyFinancialFormType,
    companyGeneralDefaultValues,
    companyGeneralFixture,
    CompanyGeneralFormType,
    MAIN_ADDRESS_ID,
} from "./steps/formType";

export interface CompanyFormType extends Omit<MyBrokerApi.MoralPersonDetailsForm, "general" | "fiscalFinancial"> {
    general: CompanyGeneralFormType;
    fiscalFinancial: CompanyFinancialFormType;
}

export const companyDefaultValues = (
    defaultValues: MyBrokerApi.MoralPersonDetails = {},
    managerId = "",
): CompanyFormType => {
    const { id, general, addresses, contact, fiscalFinancial } = defaultValues;
    return {
        id: id || 1,
        managerId,
        general: companyGeneralDefaultValues(general),
        addresses: (addresses?.length
            ? [addresses.find((address) => address.type.id === MAIN_ADDRESS_ID)]
            : [{} as MyBrokerApi.Address]
        ).map(companyAddressDefaultValues),
        contact: companyContactDefaultValues(contact),
        fiscalFinancial: companyFinancialDefaultValues(fiscalFinancial),
    };
};

export const companyFixture = (): CompanyFormType => ({
    id: 1,
    managerId: "MG1",
    general: companyGeneralFixture(),
    addresses: [companyAddressFixture()],
    contact: companyContactFixture(),
    fiscalFinancial: companyFinancialFixture(),
});

export const companyDataVerificationMapper = (data: CompanyFormType): MyBrokerApi.MoralPersonDetailsForm => {
    const { general, fiscalFinancial, ...rest } = data;
    return {
        ...rest,
        general: {
            ...general,
            language: general.language as MyBrokerApi.Language,
        },
        fiscalFinancial: {
            ...fiscalFinancial,
            endOfFiscalYear: isValid(fiscalFinancial.endOfFiscalYear)
                ? defaultDateFormat(fiscalFinancial.endOfFiscalYear, "dd/MM")
                : null,
        },
    };
};
